import { BODEGAS } from '.';

export interface IUbicacionesPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: Ubicaciones[];
}

export interface Ubicaciones {
  id_ubicacion?: string;
  nombre: string;
  numero_referencia?: string;
  codigo: string;
  bodega: string | null;
  estado: boolean;
  bodega_data?: BODEGAS;
}
export enum TipoUbicacionEnum {
  GENERICA = 'GENERICA'
}

export interface UbicacionesParams extends Partial<Ubicaciones> {
  /** Filtro multi del backend (?bodega_in=COD1,COD2). */
  bodega_in?: string;
  /**
   * Activa el scope por perfil de bodegas en `/ubicacion/` (solo el
   * Reporte de Stock lo envía; sin él, otros módulos que comparten el
   * endpoint conservan el comportamiento normal).
   */
  scope_perfil?: string;
}

export interface UbicacionNoFk extends Omit<Ubicaciones, 'bodega_data'> {

}